import React from 'react';
import SeoLandingPage from './SeoLandingPage';

const AboutPage = () => (
  <SeoLandingPage
    testIdPrefix="about"
    pretitle="About Shopperden"
    title="The property platform"
    titleAccent="without estate-agent fees"
    description="Shopperden is a direct property introduction platform serving the UK, India and Canada. Sellers list with 360° tours and AI valuations. Buyers and tenants browse without commissions. Verified agents and professionals can join too — but they don't gatekeep your home."
    ctaLabel="See properties"
    ctaTo="/properties"
    secondaryCtaLabel="For agents"
    secondaryCtaTo="/for-agents"
    bullets={[
      { title: 'Direct, not gatekept', body: 'Sellers and tenants connect directly. No 1.5% commissions, no commission-skewed advice.' },
      { title: 'Multi-country', body: 'Built ground-up for UK, India and Canada. Country-specific compliance — RBI e-Mandate, AML, RERA, EPC.' },
      { title: 'AI where it helps', body: 'Floor plan redraws, valuations, document drafts — all clearly watermarked as AI generated, never passed off as legal advice.' },
    ]}
    faq={[
      { q: 'Is Shopperden an estate agent?', a: 'No. Shopperden is a property introduction service. Listings come direct from owners or verified agents. Final decisions must be backed by independent professional advice.' },
      { q: 'Where is Shopperden registered?', a: 'Shopperden Ltd is registered in England & Wales. We operate listings in the United Kingdom, India and Canada.' },
      { q: 'How does Shopperden make money?', a: 'A small one-off introduction fee from buyers, and a 90-day subscription for agents who want to list. There is no listing fee for direct sellers during the trial.' },
    ]}
    seoTitle="About Shopperden — Property without estate agent fees | UK · India · Canada"
    seoDescription="Shopperden is a direct property introduction platform: 360° tours, AI valuations, verified users — no estate-agent commissions. UK, India, Canada."
  />
);

export default AboutPage;
